import { useTranslation } from 'react-i18next'

import { getFileItems } from '../../../../api'
import { NOTIFICATION_TYPE } from '../../../../constants/common'
import { FILE_SCOPE_REQUEST } from '../../../../constants/file'
import { useOutboundUuid } from '../../../../hooks'
import { FileAttachedItemsModal } from '../../../File'
import { updateTask } from '../../Task.api'

import {
  geTaskAttachedFiles,
  getFilesItemsApiProps,
  getTaskNextAttachedFiles,
} from './useTaskTableItemAttachedFiles.utils'

export function useTaskTableItemAttachedFiles({
  onAddNotification,
  onCloseModal,
  onReload,
  onSetModal,
}) {
  const { t } = useTranslation()

  const outboundUuid = useOutboundUuid()

  async function getFilesData(params) {
    return getFileItems(params, { outboundUuid })
  }

  async function handleSubmitRemoveAttachedFiles({ files, id, removedFiles }) {
    return updateTask(getTaskNextAttachedFiles(files, removedFiles), id).then(
      () => {
        onCloseModal()
        onReload()
        onAddNotification({
          title: t('Notification.CommonTitleRemovedAttachFilesKey'),
          type: NOTIFICATION_TYPE.success,
        })
      }
    )
  }

  function handleClickFileTag({ directoryId, itemId, objectId }) {
    onSetModal(
      <FileAttachedItemsModal
        ButtonConfirm={false}
        confirmationDescription={t(
          'Task.RemoveAttachedFilesConfirmationModalTextKey'
        )}
        directoryId={directoryId}
        entityId={itemId}
        filePreviewProps={{ scope: FILE_SCOPE_REQUEST, subject: objectId }}
        getApiProps={getFilesItemsApiProps}
        getData={getFilesData}
        getItemsFromResponse={geTaskAttachedFiles}
        objectId={objectId}
        onClose={onCloseModal}
        onSubmit={handleSubmitRemoveAttachedFiles}
      />
    )
  }

  return { handleClickFileTag }
}
